<template>
	<div class="custom-index">
		<div class="heard" style="display: flex;justify-content: space-between;color: white;width: 90%;margin: 0 auto;">
			<div>
				<el-radio-group v-model="tabPosition">
					<el-radio-button label="month">月</el-radio-button>
					<el-radio-button label="season">季</el-radio-button>
					<el-radio-button label="year">年</el-radio-button>
				</el-radio-group>
			</div>
			<div>
				{{ newTime.getHours() < 10 ? '0' + newTime.getHours() : newTime.getHours() }}:{{ newTime.getMinutes() < 10 ? '0' + newTime.getMinutes() : newTime.getMinutes() }}:{{ newTime.getSeconds() < 10 ? '0' + newTime.getSeconds() : newTime.getSeconds() }}
			</div>
			<div style="display: flex;flex-direction: column;align-items: center;font-size: 14px;">
				<div style="text-align: right;">
					<span v-if="newTime.getDay() === 0">星期日</span>
					<span v-else-if="newTime.getDay() === 1">星期一</span>
					<span v-else-if="newTime.getDay() === 2">星期二</span>
					<span v-else-if="newTime.getDay() === 3">星期三</span>
					<span v-else-if="newTime.getDay() === 4">星期四</span>
					<span v-else-if="newTime.getDay() === 5">星期五</span>
					<span v-else-if="newTime.getDay() === 6">星期六</span>
				</div>
				<div style="margin-top: 2px;">
					{{newTime.getFullYear()}}-{{newTime.getMonth() + 1}}-{{ newTime.getDate() < 10 ? '0' + newTime.getDate() : newTime.getDate() }}
				</div>
			</div>
		</div>

		<div style="padding: 10px 0;width: 90%;margin: 0 auto;">
			<div class="phone-text">地图与机器人数据统计</div>
			<div style="width: 100%;height: 200px;" id="echar4-1"></div>
			<div style="width: 100%;height: 200px;display: flex;flex-direction: column;align-items: flex-end;overflow-y: auto;color: white;">
				<div class="echar6li" v-if="mapText.list.length > 0">地图上共有机器人
					<span>{{ mapText.num }}</span> 台
				</div>
				<div class="echar6li" v-for="(obj, index) in mapText.list" :key="index+10">
					{{ obj.name }} <span>{{ obj.num }}</span> 台
				</div>
			</div>
		</div>

		<div style="padding: 10px 0;width: 90%;margin: 0 auto;">
			<div class="phone-text">地图事件数据统计</div>
			<div style="width: 100%;height: 200px;" id="echar4-2"></div>
		</div>

		<div style="padding: 10px 0;width: 90%;margin: 0 auto;">
			<div class="phone-text">各类事件完成率统计</div>
			<div style="width: 100%;height: 200px;" id="echar6-2"></div>
		</div>

		<div style="padding: 10px 0;width: 90%;margin: 0 auto;">
			<div class="phone-text">事件数据统计</div>
			<div style="width: 100%;height: 200px;" id="echar6-1"></div>
			<div style="width: 100%;height: 200px;display: flex;flex-direction: column;align-items: flex-end;overflow-y: auto;color: white;">
				<div class="echar6li" v-for="(obj, index) in eventTextList" :key="index+10">
					{{ obj.name }} <span>{{ obj.number }}</span> {{ obj.type }}
				</div>
			</div>
		</div>

		<div style="padding: 10px 0;width: 90%;margin: 0 auto;">
			<div class="phone-text">机器人值班统计</div>
			<div style="width: 100%;height: 200px;" id="echar5-1"></div>
		</div>
	</div>
</template>

<style scoped lang="less">
	.heard /deep/ .el-radio-button__inner {
		background-color: rgb(27, 31, 61);
		padding: 10px 16px;
		border: none;
		color: white;
	}

	.heard /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
		color: #FFF;
		background-color: #409EFF;
		border-color: #409EFF;
	}
</style>

<script>
	import {
		getToken,
		getItem,
		setToken
	} from '@/utils/auth'
	import {
		eventChart,
		mapEventChart,
		routeRobotNum,
		eventFinish,
		robotDutyStatistics
	} from '@/api/customIndex'
	import '@/page/customIndex/index/index.less'
	import '@/page/phone/index2.less'

	export default {
		name: 'phone2',
		data() {
			return {
				newTime: new Date(),
				nowTime: new Date().getTime(),
				titleUrl: require('../../../static/img/title.png'),
				tabPosition: 'month',
				eventTextList: [],
				mapText: {
					num: 0,
					list: []
				}
			}
		},
		mounted() {
			let that = this
			// 定时执行保持token有效
			setInterval(() => {
				that.newTime = new Date()
			}, 1000)
			setToken(that.$route.query.token)
		},
		methods: {
			mapEventChart(id, type) {
				let that = this
				mapEventChart(id, type).then(res => {
					that.Echarts42(res.data)
				})
			},
			routeRobotNum(id, type) {
				let that = this
				routeRobotNum(id, type).then(res => {
					if (res.data) {
						that.Echarts41(res.data)
						that.mapText.list = res.data
						that.mapText.num = 0
						res.data.forEach(v => {
							that.mapText.num += Number(v.num)
						})
					}
				})
			},
			eventFinish(id, type) {
				let that = this
				eventFinish(id, type).then(res => {
					that.Echarts62(res.data)
				})
			},
			eventChart(id, type) {
				let that = this
				eventChart(id, type).then(res => {
					if (res.data) {
						that.Echarts61(res.data)
						that.eventTextList = []
						that.eventTextList.push({
							name: '事件类型汇总',
							number: res.data.length,
							type: '类'
						})
						res.data.forEach(v => {
							that.eventTextList.push({
								name: v.name,
								number: v.number,
								type: '条'
							})
						})
					}
				})
			},
			robotDutyStatistics(id, type) {
				let that = this
				robotDutyStatistics(id, type).then(res => {
					that.Echarts51(res.data)
				})
			},
			// 值班统计
			Echarts51(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('echar5-1'))
				myChart.clear();
				let newLineData = []
				if (echarArray.mapList.length === 0) {
					let aaalist = []
					echarArray.dateList.forEach(rv => {
						aaalist.push(0)
					})
					newLineData.push({
						name: '',
						data: aaalist,
						type: "line",
						label: {
							show: true,
							position: 'top'
						}
					})
				} else {
					echarArray.mapList.forEach(v => {
						newLineData.push({
							name: v.name,
							data: v.valueList,
							type: "line",
							// stack: "Total",
							// emphasis: {
							//     focus: "series"
							// },
							// areaStyle: {},
							label: {
								show: true,
								position: 'top'
							}
						})
					})
				}
				var option = {
					tooltip: {
						trigger: 'axis'
					},
					grid: {
						top: '10%',
						left: '1%',
						right: '2%',
						bottom: '2%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						axisLabel: {
							rotate: 40
						},
						data: echarArray.dateList
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							formatter: '{value} h'
						},
						data: [1, 2, 3, 4, 5]
					},
					series: newLineData
				};
				myChart.setOption(option)
			},
			// 地图与机器人数据统计
			Echarts41(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('echar4-1'))
				myChart.clear();
				echarArray.forEach(res => {
					res.value = Number(res.num)
				})
				let datas = [echarArray]
				var option = {
					grid: {
						left: '5%',
						right: '4%',
						bottom: '0%',
						top: '50%'
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					series: datas.map(function(data, idx) {
						return {
							type: 'pie',
							radius: [30, '60%'],
							center: ["50%", "50%"],
							label: {
								alignTo: 'edge',
								formatter: '{time|{c}}\n{name|{b}}',
								edgeDistance: 5,
								lineHeight: 20,
								rich: {
									time: {
										fontSize: 15,
									},
									textStyle: {
										color: 'black'
									}
								}
							},
							labelLine: {
								length: 5,
								length2: 0,
								maxSurfaceAngle: 80
							},
							labelLayout(params) {
								var isLeft = params.labelRect.x < myChart.getWidth() / 2
								var points = params.labelLinePoints
								points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
									.labelRect.width
								return {
									labelLinePoints: points
								}
							},
							data: data
						}
					})
				}
				myChart.setOption(option)
			},
			// 地图事件数据统计
			Echarts42(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('echar4-2'))
				myChart.clear();
				let xData = []
				let yData = []
				echarArray.forEach(res => {
					xData.push(res.name)
					yData.push(Number(res.number))
				})
				let option = {
					xAxis: {
						type: 'category',
						data: xData,
						axisLabel: {
							rotate: 30,
							show: true,
							textStyle: {
								color: 'rgb(110,112,121)'
							},
							fontSize: 14
						}
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							show: true,
							textStyle: {
								color: 'rgb(110,112,121)'
							},
							fontSize: 14
						},
						minInterval: 1
					},
					grid: {
						top: '10%',
						left: '2%',
						bottom: '2%',
						right: '1%',
						containLabel: true,
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						}
					},
					series: [{
						name: '事件数',
						data: yData,
						type: 'bar',
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)'
						},
						itemStyle: {
							normal: {
								color: function(params) {
									var colorList = ['rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
										'#CC6699',
										'#FFFFCC', '#009966', '#663300'
									]
									return colorList[params.dataIndex]
								},
								label: {
									show: true,
									formatter: '{c}',
									position: 'top',
									fontWeight: 600,
									fontSize: 15
								}
							}
						}
					}]
				};
				myChart.setOption(option)
			},
			// 地图与机器人数据统计
			Echarts61(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('echar6-1'))
				myChart.clear();
				echarArray.map(v => {
					v.value = Number(v.number)
				})
				var datas = [echarArray]
				var option = {
					grid: {
						left: '5%',
						right: '4%',
						bottom: '0%',
						top: '50%'
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					series: datas.map(function(data, idx) {
						return {
							type: 'pie',
							radius: [30, '60%'],
							center: ["50%", "50%"],
							label: {
								alignTo: 'edge',
								formatter: '{time|{c}}\n{name|{b}}',
								edgeDistance: 5,
								lineHeight: 20,
								rich: {
									time: {
										fontSize: 15,
									},
									textStyle: {
										color: 'black'
									}
								}
							},
							labelLine: {
								length: 5,
								length2: 0,
								maxSurfaceAngle: 80
							},
							labelLayout(params) {
								var isLeft = params.labelRect.x < myChart.getWidth() / 2
								var points = params.labelLinePoints
								points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
									.labelRect.width
								return {
									labelLinePoints: points
								}
							},
							data: data
						}
					})
				}
				myChart.setOption(option)
			},
			// 各类事件完成率统计
			Echarts62(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('echar6-2'))
				myChart.clear();
				let xData = []
				let yData = []
				echarArray.forEach(res => {
					xData.push(res.name)
					yData.push(res.completionRate)
				})
				let option = {
					xAxis: {
						type: 'category',
						data: xData,
						axisLabel: {
							rotate: 30,
							show: true,
							textStyle: {
								color: 'rgb(110,112,121)'
							},
							fontSize: 14
						}
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							show: true,
							textStyle: {
								color: 'rgb(110,112,121)'
							},
							fontSize: 14
						}
					},
					grid: {
						top: '10%',
						left: '2%',
						bottom: '2%',
						right: '1%',
						containLabel: true,
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						},
						formatter: function(params) {
							var html = params[0].name + "<br>";
							for (var i = 0; i < params.length; i++) {
								html += params[i].marker + '完成率: ' + params[i].value + '%';
							}
							return html + "<br>";
						}
					},
					series: [{
						data: yData,
						type: 'bar',
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)'
						},
						itemStyle: {
							normal: {
								color: function(params) {
									var colorList = ['rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
										'#CC6699',
										'#FFFFCC', '#009966', '#663300'
									]
									return colorList[params.dataIndex]
								},
								label: {
									show: true,
									formatter: '{c}%',
									position: 'top',
									fontWeight: 600,
									fontSize: 15
								}
							}
						}
					}]
				};
				myChart.setOption(option, true)
			},
			// 调用数据
			runAjax(tenID, type) {
				let that = this
				setTimeout(function() {
					that.eventChart(tenID, type)
					that.routeRobotNum(tenID, type)
					that.eventFinish(tenID, type)
					that.mapEventChart(tenID, type)
					that.robotDutyStatistics(tenID, type)
				}, 500)
			}
		},
		watch: {
			tabPosition: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					if (getToken()) {
						let checkType = ''
						if (val === 'month') {
							checkType = 1
						} else if (val === 'season') {
							checkType = 2
						} else if (val === 'year') {
							checkType = 3
						}
						this.runAjax(this.$route.query.tenantInfoId, checkType)
						// if (getItem('userInfo').positionType === '1') {
						// 	let checkType = ''
						// 	if (val === 'month') {
						// 		checkType = 1
						// 	} else if (val === 'season') {
						// 		checkType = 2
						// 	} else if (val === 'year') {
						// 		checkType = 3
						// 	}
						// 	this.runAjax(that.$route.query.tenantInfoId, checkType)
						// }
					}
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/page/phone/index2.vue